// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-container[data-v-0988ba5c]{min-height:100vh;display:flex;flex-direction:column;flex:1 1 0%}.app-container .account-container[data-v-0988ba5c]{margin-left:auto;margin-right:auto;max-width:100%;max-width:clamp(100%,112rem,100%)}@media (min-width:768px){.app-container[data-v-0988ba5c]{--bg-opacity:1;background-color:#f2f2f2;background-color:rgba(242,242,242,var(--bg-opacity))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
